import { AddAdminFormDataType } from '../components/role/AddUser'

export const AddAdminData: AddAdminFormDataType = {
  firstName: '',
  lastName: '',
  department: '',
  email: '',
  password: '',
  status: '',
  user_role: '',
}
